<template>
  <div
    class="bingo-card h-1/5 w-1/5"
    :class="classes"
    :style="styles"
    @click="toggleActive"
  >
    <div
      class="bingo-card__overlay"
      :style="{backgroundColor: config.color}"
    >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    collectionName: {
      type: String
    },

    config: {
      default: () => {
        return {
          color: "#000000"
        }
      },
      type: Object
    },

    item: {
      required: true
    }
  },

  data () {
    return {
      active: false
    }
  },

  computed: {
    classes () {
      return {
        "active": this.active
      }
    },

    styles () {
      return {
        "background-image": `url('${require('@/assets/images/'+this.collectionName+'/'+this.item.filename)}')`
      }
    }
  },

  methods: {
    toggleActive () {
      this.active = !this.active
    }
  }
}
</script>

<style>
.bingo-card {
  @apply relative;
  @apply border border-black;

  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;

  background-position: center;
  background-repeat: no-repeat;
  background-size: auto 100%;
}

.bingo-card .bingo-card__overlay {
  @apply z-20;
  @apply absolute top-0 right-0 bottom-0 left-0;
  @apply opacity-0;

  mix-blend-mode: multiply;
  transition: all 300ms;
}

.bingo-card:hover .bingo-card__overlay {
  @apply opacity-25;
}

.bingo-card.active .bingo-card__overlay {
  @apply opacity-50;
}
</style>
